import Select, { StylesConfig, SingleValue } from 'react-select';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import * as React from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { LocationService } from "../Services/LocationService";
import ReduxStore from '../../Redux/Store/IndexStore';
const hiddenRoutes = [
  "/RolePermission",
  "/User",
  "/COAMaster",
  "/CustomerMaster",
  "/VendorMaster",
  "/DocumentMaster",
  "/ProductMaster",
  "/ProcessMaster",
  "/PartTemplate",
  "/WorkstationMaster",
  "/NCRCodeMaster",
  "/PriceBreakdown",
  "/Reports",
  "/SearchAll",
  "/overview",
  "/LocationMaster"
];


type Location = {
  code: string;
  name: string;
  locationId: Number,
};

type SelectOption = {
  value: string;
  label: string;
  id: Number;
};

// interface Props {
//   onChange?: (code: string) => void;
// }

interface Props extends RouteComponentProps {
  onChange?: (code: string) => void;
}


interface State {
  locations: Location[];
  selectedCode?: string;
  locationId: Number;
  requestlist?: any;
}

export class LocationDropdown extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      locations: [],
      selectedCode: undefined,
      locationId: 0,
    };
  }

  componentDidMount() {
    this.getLocation();
  }

  getLocation = () => {
    let requestlist = { ...this.state.requestlist };
    LocationService.GetLocationAll(requestlist)
      .then((result: Location[] | null) => {
        if (result && result.length > 0) {
          const storedId = Number(localStorage.getItem("locationId"));
          const matching = result.find(loc => loc.locationId === storedId);
          const selected = matching || result[0];
          if (!matching) {
            localStorage.setItem("locationId", String(selected.locationId));
              ReduxStore.dispatch({
              type: 'SET_LOCATION',
              payload: selected.locationId,
            });
          }

          
          this.setState({
            locations: result,
            selectedCode: selected.code,
            locationId: selected.locationId
          });

          if (this.props.onChange) {
            this.props.onChange(selected.code);
          }
        }
      })
      .catch((err: any) => {
        toast.error(`Server Error, ${err}`);
      });
  };

  getOptions(): SelectOption[] {
    return this.state.locations.map((loc) => ({
      value: loc.code,
      label: `${loc.name} (${loc.code})`,
      id: loc.locationId
    }));
  }

  handleChange = (selected: SingleValue<SelectOption>) => {
    if (selected) {
      this.setState({ selectedCode: selected.value, locationId: selected.id });
      localStorage.setItem("locationId", String(selected.id));
      ReduxStore.dispatch({
        type: 'SET_LOCATION',
        payload: selected.id,
      });
      if (this.props.onChange) {
        this.props.onChange(selected.value);
      }
    }
  };

  render() {
     const { location } = this.props;
      if (hiddenRoutes.includes(location.pathname)) {
        return null;
      }

    const options = this.getOptions();
    const selectedOption = options.find(
      (opt) => opt.value === this.state.selectedCode
    );

    const customStyles: StylesConfig<SelectOption, false> = {
      control: (provided) => ({
        ...provided,
        padding: '1px',
        borderRadius: '8px',
        borderColor: '#ccc',
        color: '#000000',
        fontWeight: 'normal', // No bold font
        boxShadow: 'none',
        backgroundColor: '#cce0ff', // Dark blue background
        '&:hover': {
          borderColor: '#001f4d', // Slightly darker blue on hover
        },
      }),
      menu: (provided) => ({
        ...provided,
        backgroundColor: '#f8f9fa',
        borderRadius: '8px',
        marginTop: '4px',
        zIndex: 5,
      }),
      menuList: (provided) => ({
        ...provided,
        backgroundColor: '#f8f9fa',
        padding: 0,
      }),
      option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
          ? '#003366'
          : state.isFocused
          ? '#cce0ff'
          : 'transparent',
        color: state.isSelected ? 'white' : '#003366', // White for selected, dark blue otherwise
        padding: '10px',
        cursor: 'pointer',
      }),
      singleValue: (provided) => ({
        ...provided,
        color: '#000000', // White font in selected value
        fontWeight: 'normal', // No bold font
      }),
    };
    

    return (
      <div className="me-2">
        <Select
          styles={customStyles}
          options={options}
          value={selectedOption}
          onChange={this.handleChange}
          isSearchable={false}
          isClearable={false}
          placeholder="Select a location..."
        />
      </div>
    );
  }
}

// export default LocationDropdown;
export default withRouter(LocationDropdown);

